import i from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function l(e) {
  o(1, arguments);
  var r = i(e), t = r.getMilliseconds();
  return t;
}
export {
  l as default
};
